import {Component, Input, OnDestroy, OnInit, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'app-timer',
  templateUrl: './countdown-timer.component.html',
  styleUrls: ['./countdown-timer.component.scss']
})
export class CountdownTimerComponent implements OnInit, OnDestroy {

  _auctionDate: Date;

  @Input('selectedAuctionId') selectedAuctionId: number;

  @Input('auctionEnded') auctionEnded: boolean;
  @Input('auctionStarted') auctionStarted: boolean;

  @Input() set auctionDeadline(value: Date) {
    this._auctionDate = value && new Date(value);
    this.timeBetweenDates();
    const self = this;
    clearInterval(this.timer);
    this.timer = setInterval(function() {
      self.timeBetweenDates();
    }, 1000);
  }

  @Output() onAuctionEnded = new EventEmitter<any>();

  timer;
  seconds: string;
  minutes: string;
  hours: string;
  days: string;

  constructor() { }

  ngOnInit(): void {
  }

  timeBetweenDates() {
    if (this._auctionDate && this.auctionEnded===false) {
      let dateEntered = this._auctionDate;
      let now = new Date();
      let difference = dateEntered.getTime() - now.getTime();

      if (difference <= 0) {
        this.days = '00';
        this.hours = '00';
        this.minutes = '00';
        this.seconds = '00';
        clearInterval(this.timer);
        this.onAuctionEnded.emit(this.selectedAuctionId);
      } else {
        let seconds = Math.floor(difference / 1000);
        let minutes = Math.floor(seconds / 60);
        let hours = Math.floor(minutes / 60);
        let days = Math.floor(hours / 24);

        hours %= 24;
        minutes %= 60;
        seconds %= 60;

        this.days = days.toString().padStart(2, '0');
        this.hours = hours.toString().padStart(2, '0');
        this.minutes = minutes.toString().padStart(2, '0');
        this.seconds = seconds.toString().padStart(2, '0');

        if (days === 0 && hours === 0 && minutes === 0 && seconds === 0) {
          clearInterval(this.timer);
          this.onAuctionEnded.emit(this.selectedAuctionId);
        }
      }
    } else {
      this.days = '00';
      this.hours = '00';
      this.minutes = '00';
      this.seconds = '00';
      clearInterval(this.timer);
      this.onAuctionEnded.emit(this.selectedAuctionId);
    }
  }

  ngOnDestroy() {
    clearInterval(this.timer);
  }

}
